// Centralised route paths. Single source of truth so route declarations (routes.tsx)
// and any consumer (e.g. SSO redirect URIs) stay in sync.
export const XIMI_SSO_CALLBACK_PATH = '/ximi/sso';
export const XIMI_LOGIN_SELECT_ACCOUNT_PATH = '/ximi/login/select-account';
export const XIMI_LOGIN_MANUAL_ENTRY_PATH = '/ximi/login/manual-entry';
